import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Login.css"; // Importar los estilos personalizados
import logo from "../assets/logo1.png"; // Imagen del logo
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../components/Navbar';

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [alert, setAlert] = useState({ type: "", text: "" }); // 🔹 mensaje con tipo
  const navigate = useNavigate();

  useEffect(() => {
    // Asegurarse de que Bootstrap está inicializado correctamente
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, form);
      // Guardar el token sin el prefijo "Bearer"; el interceptor lo añadirá
      localStorage.setItem("token", res.data.token);

      // Mensaje de éxito en verde
      setAlert({ type: "success", text: "Inicio de sesión exitoso. Redirigiendo..." });

      setTimeout(() => navigate("/dashboard"), 2000);
    } catch (error) {
      // Mensaje de error en rojo
      setAlert({ type: "error", text: error.response?.data?.message || "Error en el login" });
    }
  };

  return (
    <>
      <Navbar />

      <div className="login-container">
        <div className="login-card">
          <img src={logo} alt="Logo" style={{ height: 48, marginBottom: 12 }} />
          <h2 className="login-title">Iniciar Sesión</h2>
          
          {/* Alertas de éxito o error */}
          {alert.text && (
            <div
              className={`alert ${
                alert.type === "success" ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              {alert.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Correo Electrónico"
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Contraseña"
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-login w-100 d-flex justify-content-center align-items-center">
              Iniciar Sesión
            </button>
          </form>

          <div className="login-footer">
            <p>¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link></p>
            <p className="forgot-password-link">
              <Link to="/forgot-password">
                <i className="bi bi-question-circle"></i> ¿Olvidaste tu contraseña?
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
